import { Guarantee } from '@/constants/guarantee';

const TitleId = 'guarantee-title';

export function GuaranteeSection() {
  return (
    <section id="guarantee" aria-labelledby={TitleId} className="bg-graphite text-paper">
      <div className="section-container grid gap-8 py-12 sm:py-14 lg:grid-cols-12 lg:items-center lg:gap-16">
        <div className="lg:col-span-4">
          <h2 id={TitleId} className="text-2xl font-extrabold tracking-tight sm:text-3xl">
            {Guarantee.title}
          </h2>
          <p className="mt-2 text-lg leading-relaxed text-paper/75">{Guarantee.tagline}</p>
        </div>
        <ul className="grid gap-6 sm:grid-cols-2 sm:gap-10 lg:col-span-8">
          {Guarantee.promises.map((promise) => {
            const PromiseIcon = promise.icon;
            return (
              <li key={promise.id} className="flex gap-4">
                <span className="flex size-11 shrink-0 items-center justify-center rounded-full border border-paper/25 text-pad">
                  <PromiseIcon aria-hidden="true" className="size-5" />
                </span>
                <div>
                  <h3 className="text-lg font-bold">{promise.title}</h3>
                  <p className="mt-1 leading-relaxed text-paper/75">{promise.description}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}